module.exports = __webpack_public_path__ + "img/guide-item-bg.ea6633ce.png";